export const pcMenuCategoryNames = new Map([
  ['management', '학원 관리'],
  ['bill', '학원비'],
  ['attendance', '출결'],
  ['post', '글 관리'],
  ['homeworkAndSchedule', '숙제'],
  // ['chat', '상담톡'],
  ['report', '리포트'],
  ['counsel', '상담'],
  ['textbook', '교재'],
  ['message', '문자메시지'],
  // ['etc', '기타'],
]);
